import type {
  IAccountRepository,
  DetectAccountByCountryResult,
} from '../repositories/account.repository'
import type { Account } from '../entities/account.entity'

/**
 * Сервис аккаунтов (accounts).
 * Делегирует вызовы репозиторию, соответствующие эндпоинтам бэкенда:
 * GET /accounts/:account_id, GET /accounts/detect-by-country/:country_iso
 */
export class AccountService {
  constructor(private readonly accountRepository: IAccountRepository) {}

  /**
   * Получить аккаунт по ID.
   */
  async getAccountById(accountId: string): Promise<Account | null> {
    return this.accountRepository.findById(accountId)
  }

  /**
   * Определить аккаунт по ISO коду страны (с fallback на UA).
   */
  async detectAccountByCountry(countryIso: string): Promise<DetectAccountByCountryResult> {
    return this.accountRepository.detectByCountry(countryIso)
  }
}
